import { iFilterItem } from "./filterTypes";
import { IInvoice } from "./commonTypes";
import { IQuoteFormSection } from "./quoteFormTypes";
import { EventSourceEnum } from "../constants/enums";
import { IAdmin } from "./userType";

export interface iType {
	name?: string;
	value: string;
	noCms?: boolean;
}

export interface iAddressType {
	place_id: string | number;
	latitude: number;
	longitude: number;
	place_name: string;
}

export interface iVendorEventRecord {
	id: string;
	isWhatsappGroupCreated?: boolean;
	cancellationReason: iType;
	declineReason: iType;
	otherDeclineReason: string;
}

export enum VendorEventResponseStatusesEnum {
  InActive = 0,
  Invited = 1,
  AvailableForBidding = 2,
  Bidding = 3,
  Accepted = 4,
  Completed = 5,
  Rejected = 6,
  RejectedByCustomer = 7,
  Cancelled = 8,
  AssignedByAdmin = 9,
}

export interface iEventType {
	id: string;
	name: string;
	orderNumber: string;
	serviceCategory: iType;
	eventDate: string;
	startTime: string;
	endTime: string;
	isDateFlexible: boolean;
	guestsCount: number;
	minBudget: number;
	maxBudget: number;
	budget: number;
	isBudgetFlexible: boolean;
	serviceEventType: iType;
	otherServiceEventType: iType;
	providerType: iType;
	otherProviderType: iType;
	serviceSetups: iType[];
	otherServiceSetups: iType[];
	dietaryRequirements: iType[];
	otherDietaryRequirements: iType;
	typeOfCuisines: iType[];
	typeOfFoods: iType[];
	otherKindOfFoods: iType;
	otherCourses?: iType;
	extendedServices: iType[];
	otherExtendedServices: iType[];
	city: number;
	address: iAddress;
	isSearchingVenue: boolean;
	additionalRemarks: string;
	status: EventStatusEnum;
	createdAt: string;
	updatedAt: string;
	customer: iCustomer;
	channelUrl: string;
	vendorStatus: VendorEventResponseStatusesEnum;
	vendorSendBirdId: string;
	vendorEventStatus: number;
	notificationCount: number;
	customerTwilioCID?: string;
	allowDirectCall: boolean;
	request: IRequest | null;
	type: string;
	invoices: IInvoice[];
	paymentBalance: IPaymentBalance;
	timeOfDay: iType;
	budgetType: iType;
	courses: iType[];
	dishType: string;
	providerOptions: iType;
	providerOptionsMultiple: iType[];
	isEventVisibleToUser: boolean;
	userSubmissionStatus: EventUserSubmissionStatus;
	adminMessage?: string;
	vendorEventRecord: iVendorEventRecord;
	messages?: IEventDetailMessages[];
	totalUnreadMessageCount?: number;
	source: EventSourceEnum;
}
export interface iAddress {
	place_id: string;
	latitude: string;
	longitude: string;
	place_name: string;
	addressLine2: string;
}
export enum RoleEnum {
	Admin = "admin",
	Customer = "customer",
	Vendor = "vendor",
}
export interface IPaymentBalance {
	amountPayable: number;
	amountReceivable: number;
	shippingFee: number;
	vatAmount: number;
	subTotal: number;
	discountAmount: number;
	vatPercentage: number;
	paymentTotal: number;
	id: string;
}

export interface iCustomer {
	id: string;
	firstName: string;
	lastName: string;
	sendbirdId: string;
	phoneNumber: string;
}

export interface iFlatEvent {
	id: string;
	createdAt?: string;
	name: string;
	guestsCount: number;
	city: string;
	customerName: string;
	eventDate: string;
	declinedBy?: string;
	showIndicator: boolean;
	kindOfFood: string[];
	occasionType: string;
	budget: number;
	isFlexible: boolean;
	serviceType: string;
	type: string;
}
export interface iFilterType {
	filters: iFilterItem[];
	gridId: string;
	gridType: string;
	operator?: string;
	meta?: any;
}
export enum EVENT_TYPE {
	DIRECT_REQUEST = 1,
	IN_PROGRESS = 2,
	APPROVED = 3,
	AI_DIRECT_REQUEST = 4,
}

export enum RESPOND_TO_EVENT_TYPES {
	ACCEPT = 1,
	DECLINE = 2,
}

export enum EVENT_TYPE_HISTORY {
	COMPLETED = 1,
	DECLINED = 2,
}

export interface iEventProp {
	gridId: string;
	eventType: string | null;
	showSave: boolean;
	title: string;
	queryParams: string;
	isDeclinedGrid?: boolean;
	showPrepaid?: boolean;
}
export interface iRespondEventPayload {
	id: string;
	status: number;
	declineReason: {
		value: string;
	};
	otherDeclineReason: string;
	firstVendorInteraction?: boolean;
}
export enum EVENT_RESPOND {
	ACCEPT = 1,
	DECLINE = 2,
}
export interface iEventBids {
	currentBid: iBidType;
	history: iBidType[];
}

export enum EVENT_BID_STATUSES {
  Pending = 0,
  Accepted = 1,
  Rejected = 2,
}

export interface iBidType {
	id: string;
	eventId: string;
	amount: number;
	vat: number;
	municipalityTax: number;
	comment: string;
	quoteUrl: string;
	openAiFileId: string;
	aiBidsExtractionLogId: string;
	status: EVENT_BID_STATUSES;
	createdAt: string;
	promoAmount: number;
	discountedAmount: number;
	amountVat: number;
	serviceSubTotal: number;
	processingFee: number;
	processingFeeVat: number;
	feeSubTotal: number;
	netTotal: number;
	vatTotal: number;
	grandTotal: number;
	subTotal: number;
	total: number;
	isVatInclusive: number;
	isMunicipalityTaxInclusive: number;
	declineReason: string | null;
	otherDeclineReason: string | null;
	brandedQuotePdfUrl: string | null;
	promocode: string | null;
	sections: IQuoteFormSection[];
	vatRate: number;
	promoCap: number;
	processingFeeVatRate: number;
	quoteNumber?: string;
	bidSubmittedByAdmin?: IAdmin | null;
	updatedAt: string;
	isRead: boolean;
	logoBackgroundColor?: string;
	logoTextColor?: string;
}

export interface iQuoteProp {
	currentBid: iBidType;
	history: iBidType[];
	vendorStatus: VendorEventResponseStatusesEnum;
	handleShowNewQuoteForm: () => void;
	changeTab: (tab: string) => void;
	invoices?: IInvoice[];
	openPdfFile: (url: string) => void;
}

export enum EventStatusEnum {
	InActive = 0,
	Active = 1,
	Accepted = 2,
	Completed = 3,
	Cancelled = 4,
}
export interface iSaveQuoteModalPayload {
	vatAmountValue?: string;
	municipalityTaxAmountValue?: string;
}

export interface iEventDetailCMS {
	[key: string]: string;
}
export interface iFilePayload {
	file: File;
	directory: string;
	onProgress?: (percent: number) => void;
}

export interface iFileResponse {
	imageUrl: string;
}

export interface iEventActionResp {
	event: iEventType;
	message: string;
}

export enum VAT_INCLUSIVE_STATUSES {
	Yes = 1,
	No,
	NotRegistered,
}

export enum MUNICIPALITY_TAX_INCLUSIVE_STATUSES {
	Yes = 1,
	No,
	NotApplicable,
}

export enum EVENT_BID_STATUSES {
	PENDING = 0,
	ACCEPTED,
	REJECTED,
}

export interface IShopifyLineItemProperty {
	name: string;
	value: string;
}

export interface IShopifyLineItem {
	name?: string;
	title?: string;
	properties?: IShopifyLineItemProperty[];
}

export interface IRequest {
	id: string;
	name: string;
	guestCount: number;
	status: number;
	menu: string;
	eventDate: string;
	payload?: {
		note: string;
		line_items?: IShopifyLineItem[];
	};
	startTime: string;
	endTime: string | null;
	customerName: string;
	createdAt: string;
	updatedAt: string;
	orderId: number;
	event?: iEventType;
	expireAt: string;
	price: number;
}

export enum EventRequestStatusEnum {
	Active = 0,
	Accepted = 1,
	Reject = 2,
	OnHold = 3,
	Cancelled = 4,
	Expired = 6,
}

export enum EventUserSubmissionStatus {
	PartiallyFilled = 0,
	FilledShared = 1,
	FilledNotShared = 2,
}

export enum WhatsAppGroupStatusEnum {
	active = "active",
	inactive = "inactive",
}

interface WhatsAppGroupParticipant {
	id: string;
	rank: "admin" | "member" | string;
}

export interface IWhatsAppGroupInfo {
	id: string;
	groupId: string;
	name: string;
	participants: WhatsAppGroupParticipant[];
	unprocessedParticipants: string[];
	createdBy: string;
	invitationLink: string;
	invitationExpirationTime: string; // or Date if you convert it
	vendorId: string;
	vendorEventId: string;
	eventId: string;
	groupStatus: WhatsAppGroupStatusEnum; // add other possible statuses if needed
}

export enum VendorEventStatusEnum {
  AvailableForBidding = 0, // user direct request
  Bidding = 1, // active avents
  Accepted = 2,
  RejectedByCustomer = 3,
  RejectedByVendor = 4,
  Cancelled = 5,
  Completed = 6,
  Admin = 7,
  AvailableForBiddingAiRequest = 8,
}

export interface IEventDetailMessages {
	vendorEventStatus: VendorEventStatusEnum;
	isNewModelChannel?: boolean;
	channelUrl: string;
	unreadMessageCount: number | null;
	hasUnreadMention?: boolean;
	lastMessage: string | null;
	lastMessageType: string | null;
	file: any | null;
	lastMessageAt: string | null;
	vendorEventId: string;
	isWhatsappGroupCreated: boolean;
	logoBackgroundColor?: string;
	customer: iCustomer;
}
